__turbopack_context__.v({
  "button": "AuthWalletConnected-module-scss-module__9aoNpW__button",
  "icon": "AuthWalletConnected-module-scss-module__9aoNpW__icon",
  "text": "AuthWalletConnected-module-scss-module__9aoNpW__text",
});
